export const rem = (pixels: number, baseSize = 16): string =>
  `${pixels / baseSize}rem`;
